import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { Alert, Card, Checkbox, Form, Input, Typography } from "antd";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import Button from "../../components/ui/Button";
import { loginUser } from "../../api/auth.api";
import { useAuth } from "../../hooks/useAuth";
import Logo from "../../assets/logo-icon-transparent.png";

interface LoginValues {
  email: string;
  password: string;
  remember_me?: boolean;
}

const LoginPage = () => {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const onFinish = async (values: LoginValues) => {
    try {
      setSubmitting(true);
      setError(null);
      const { data } = await loginUser(values);
      setSession({
        user: data.user,
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
      });
      toast.success("Welcome back");
      navigate("/dashboard");
    } catch (_error) {
      setError("Invalid email or password");
      toast.error("Login failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <Card className="auth-card">
        <div style={{ textAlign: "center", marginBottom: "16px" }}>
          <img
            src={Logo}
            alt="ePost Global"
            style={{ height: "80px", width: "80px", objectFit: "contain" }}
          />
          <Typography.Title
            level={3}
            style={{ marginTop: "8px", marginBottom: 0 }}
          >
            ePost Assist
          </Typography.Title>
        </div>
        <Typography.Title level={2}>Sign in</Typography.Title>
        {error ? <Alert type="error" showIcon message={error} /> : null}
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Enter your email" }]}
          >
            <Input prefix={<MailOutlined />} placeholder="name@company.com" />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Enter your password" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Your password"
            />
          </Form.Item>
          <Form.Item name="remember_me" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={submitting} block>
            Login
          </Button>
        </Form>
        <div style={{ textAlign: "center", marginTop: "16px" }}>
          <Button type="link" onClick={() => navigate("/chat")}>
            ← Back to Chat
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
